module.exports = __webpack_public_path__ + "static/media/iconImage.e253c9af.png";